import { useEffect, useState, useCallback } from "react";
import successSound from "../sounds/success.mp3";
import errorSound from "../sounds/error.mp3";
import silentSound from "../sounds/silence.mp3";

export const useAudioManager = () => {
  const [hasInteracted, setHasInteracted] = useState(false);
  const [silentAudio] = useState(() => new Audio(silentSound));

  const handleUserInteraction = useCallback(() => {
    setHasInteracted(true);
  }, []);

  useEffect(() => {
    window.addEventListener("click", handleUserInteraction);
    return () => window.removeEventListener("click", handleUserInteraction);
  }, [handleUserInteraction]);

  useEffect(() => {
    if (hasInteracted) {
      silentAudio.play().catch(console.error);
    }
  }, [hasInteracted, silentAudio]);

  const playSuccessSound = useCallback(() => {
    if (hasInteracted) {
      const audio = new Audio(successSound);
      audio.play().catch(console.error);
    }
  }, [hasInteracted]);

  const playErrorSound = useCallback(() => {
    if (hasInteracted) {
      const audio = new Audio(errorSound);
      audio.play().catch(console.error);
    }
  }, [hasInteracted]);

  return {
    hasInteracted,
    playSuccessSound,
    playErrorSound,
  };
};
